import { Flows, Recommendation } from '../../../../src/types/types'
import { FlowKey, Section } from './types'

export const SUMMARY_REQUIREMENT_FLOW_KEYS: FlowKey[] = [
  'identity',
  'financial',
  'residential',
  'guarantor',
  'company',
  'additionalDetails',
]

export const progressToSectionData = (progress: {
  flows: Flows
  recommendations: Recommendation[]
}): Section[] => {
  const flowSectionsAndProgress = Object.keys(progress.flows).map(key => {
    const sectionName = key as FlowKey
    const section = progress.flows[sectionName]
    const actions = section?.actions

    return {
      name: sectionName,
      isBlocked: section.isBlockedByDependenciesOrRecommendations,
      progress: actions.reduce(
        (acc, curr) => {
          return {
            completed: curr.completed ? acc.completed + 1 : acc.completed,
            total: actions.length,
          }
        },
        { completed: 0, total: actions.length },
      ),
    }
  })

  return flowSectionsAndProgress
}

export const progressToOutstandingAction = (progress: {
  flows: Flows
  recommendations: Recommendation[]
}): Recommendation | undefined => {
  return progress.recommendations.find(
    recommendation => recommendation.completed === false,
  )
}

export const hasStartedJourney = (sections: Section[]): boolean =>
  sections.some(section => section.progress.completed > 0)

export const hasCompletedJourney = (sections: Section[]): boolean =>
  sections.length > 0 &&
  sections.every(section => section.progress.completed >= section.progress.total)

export const getResumeFlowKey = (sections: Section[]): FlowKey | undefined => {
  const incomplete = sections.find(
    section => section.progress.completed < section.progress.total,
  )
  return incomplete?.name
}

export const getStartFlowKey = (sections: Section[]): FlowKey => {
  const termsAndConditions = sections.find(
    section => section.name === 'termsAndConditions',
  )
  if (termsAndConditions !== undefined) {
    return 'termsAndConditions'
  }
  return sections[0]?.name ?? 'termsAndConditions'
}

export const getVisibleSummarySections = (sections: Section[]): FlowKey[] => {
  const flowNames = new Set(sections.map(section => section.name))
  return SUMMARY_REQUIREMENT_FLOW_KEYS.filter(key => flowNames.has(key))
}
